<script>
  import axios from "axios";
  import { link } from "svelte-spa-router";
  import Layout from "../../Layout/Layout.svelte";
  import MenuHeading from "../../shared/MenuHeading.svelte";
  import config from "../../stores/config";
  import { Circle } from "svelte-loading-spinners";
  import * as ls from "local-storage";

  let uploading = false;

  let genSKU = (name, size = 5) => {
    if (name) {
      let temp = name
        .replaceAll("  ", " ")
        .split(" ")
        .slice(0, size)
        .map((words) => words.slice(0, 3))
        .join("-")
        .replaceAll("--", "-")
        .replaceAll("--", "-")
        .toUpperCase();
      return temp;
    } else return "";
  };

  let genStyleSKU = (styleName, styleSize) => {
    return `${genSKU(styleName, 2)}-${genSKU(styleSize, 5)}`;
  };

  let name = null;
  let price = null;
  let inventoryLevel = null;
  let size = null;
  let SKU = null;
  let description = null;
  let patternID = null;
  let patternPieces = null;
  let costingN = null;
  let contrast = null;

  const handleClear = () => {
    name = null;
    price = null;
    inventoryLevel = null;
    size = null;
    SKU = null;
    description = null;
    patternID = null;
    patternPieces = null;
    costingN = null;
    contrast = null;
  };

  const handleSubmit = async (e) => {
    if (
      $config.fstyles.find(({ label }) =>
        $config.f._has_(label, `${size}${name}`)
      )
    ) {
      alert("⚠ This Style already exists");
      return;
    }

    if (name) SKU = genStyleSKU(name, size);
    if (!name) alert("Style Name Missing");
    else if (!price) alert("Price missing!");
    else if (!size) alert("Size missing!");
    else if (!SKU) alert("SKU missing!");
    else {
      uploading = true;

      let data = {
        name,
        price,
        inventoryLevel: inventoryLevel || 0,
        size,
        SKU,
        description,
        patternID,
        patternPieces,
        costingN,
        contrast,
      };

      axios
        .post(`${$config.backendURL}/fstyles`, data, {
          headers: { authorization: ls.get("jwt") },
        })
        .then((res) => {
          console.log(res.data);
          uploading = false;
          alert(`☑ Added Successfully`);
          window.location.reload();
          handleClear();
        })
        .catch((err) => {
          alert("There was a problem, Refresh the page and retry");
          console.log(err);
          uploading = false;
        });
    }
  };
</script>

<svelte:head>
  <title>Add Style to Stock | Fabi CC System</title>
</svelte:head>

<Layout>
  <MenuHeading
    title="Add new Style to Stock"
    description="Fill out the form below to enter the item details. All fields are REQUIRED."
  />

  <div class="flex justify-end mb-6">
    <a class="btn btn-green-outline" use:link href="/fstyles">
      <i class="fas fa-arrow-left mr-3" />
      Return to Styles
    </a>
  </div>

  <form
    on:submit|preventDefault={handleSubmit}
    class="grid grid-cols-1 gap-y-4 text-gray-500 pb-8"
  >
    <div class="grid grid-cols-2 gap-8">
      <div class="grid grid-cols-3 gap-2 items-center">
        <div>Style Name :</div>
        <input
          class="col-span-2 shadow-sm placeholder-gray-300"
          type="text"
          bind:value={name}
          placeholder="Style Name"
        />
      </div>
      <div class="grid grid-cols-3 gap-2 items-center">
        <div>Unit Price :</div>
        <input
          class="col-span-2 shadow-sm placeholder-gray-300"
          type="number"
          step="any"
          bind:value={price}
          placeholder="Unit Price"
        />
      </div>
    </div>

    <div class="grid grid-cols-2 gap-8">
      <div class="grid grid-cols-3 gap-2 items-center">
        <div>Pattern ID :</div>
        <input
          class="col-span-2 shadow-sm placeholder-gray-300"
          type="text"
          bind:value={patternID}
          placeholder="Pattern ID"
        />
      </div>
      <div class="grid grid-cols-3 gap-2 items-center">
        <div>Pattern Pieces :</div>
        <input
          class="col-span-2 shadow-sm placeholder-gray-300"
          type="text"
          bind:value={patternPieces}
          placeholder="Pattern Pieces"
        />
      </div>
    </div>

    <div class="grid grid-cols-2 gap-8">
      <div class="grid grid-cols-3 gap-2 items-center">
        <div>Inventory Level :</div>
        <input
          class="col-span-2 shadow-sm placeholder-gray-300"
          type="number"
          step="any"
          bind:value={inventoryLevel}
          placeholder="This field is not compulsory"
        />
      </div>
      <div class="grid grid-cols-3 gap-2 items-center">
        <div>Description :</div>
        <textarea
          class="col-span-2 shadow-sm placeholder-gray-300"
          type="text"
          bind:value={description}
          placeholder="Description"
          rows="2"
        />
      </div>
    </div>

    <div class="grid grid-cols-2 gap-8">
      <div class="grid grid-cols-3 gap-2 items-center">
        <div>Size:</div>
        <input
          class="col-span-2 shadow-sm placeholder-gray-300"
          type="text"
          bind:value={size}
          placeholder="Size"
        />
      </div>
      <div class="grid grid-cols-3 gap-2 items-center">
        <div>Costing Number:</div>
        <input
          class="col-span-2 shadow-sm placeholder-gray-300"
          type="text"
          bind:value={costingN}
          placeholder="Costing Number"
        />
      </div>
    </div>

    <div class="grid grid-cols-2 gap-8">
      <div class="grid grid-cols-3 gap-2 items-center">
        <div>Contrast [Optional]:</div>
        <input
          class="col-span-2 shadow-sm placeholder-gray-300"
          type="text"
          bind:value={contrast}
          placeholder="Contrast"
        />
      </div>
    </div>

    {#if uploading}
      <div class="grid grid-cols-1 gap-8">
        <div class="flex items-center justify-center btn btn-green-outline">
          <Circle size="25" color="rgb(16, 185, 129)" unit="px" />
          <span class="ml-4">Please wait...</span>
        </div>
      </div>
    {:else}
      <!-- else content here -->
      <div class="grid grid-cols-2 gap-8">
        <button class="btn btn-green-outline" on:click={handleClear}>
          <i class="fas fa-times-circle mr-3" />
          Clear Form
        </button>
        <button class="btn btn-green" on:click={handleSubmit}>
          <i class="fas fa-check-circle mr-3" />
          Save to Database
        </button>
      </div>
    {/if}
  </form>
</Layout>
